module.exports = __webpack_public_path__ + "assets/filter_bicycle-28668b.svg";